import React from "react";
import Loading from "../components/loading/Loading";

const NotFound = () => {
  return (
    <div className="notfound">
      <Loading text="Ez az oldal sajnos nem található!" />
    </div>
  );
};

export default NotFound;
